import { Routes, Route } from 'react-router-dom';
import Segmentacoes from '../components/Products/SmartCampaigns/pages/NovaSegmentacao';

const SmartRoutes = () => (
  <Routes>
    <Route path="segmentacoes" element={<Segmentacoes />} />
  </Routes>
);

export default SmartRoutes;